import { NgModule } from '@angular/core';
import { Level1GameCoreModule } from './level1-core/level1-core.module';
import { Level2GameCoreModule } from './level2-core/level2-core.module';
import { Level3GameCoreModule } from './level3-core/level3-core.module';
import { MasterGameCoreModule } from './master-game-core/master-game-core.module';
import { ValuesGameCoreModule } from './values-game-core/values-game-core.module';
import { OrientationGameCoreModule } from './orientation-game-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    Level1GameCoreModule,
    Level2GameCoreModule,
    Level3GameCoreModule,
    MasterGameCoreModule,
    ValuesGameCoreModule,
    OrientationGameCoreModule,
  ],
})
export class GameCoreModule {}
